const config = {
  navTitle: "Tournoi National Agricole Rugby",
  titlePart1: "Tournoi National ",
  titlePart2: "Agricole Rugby",
  date: "Du 1er au 3 Avril 2025",
  logo: {
    altName: "Agro Campus 64",
    src: "/logo512.png",
  },
  body: "Bienvenue au Tournoi National Agricole 2025 à Soustons. Ce site web vous accompagnera tout au long de l'événement placé sous le signe du rugby et de l'amitié. Bon tournoi !",
  mainButton: {
    label: "Suivre les résultats",
    link: "/games",
  },
  secondaryButton: {
    label: "Live vidéo 📹",
    link: "https://www.youtube.com/@lpaorthez401",
  },
  altLink: {
    label: "Téléchargez le dossier d'accueil",
    link: "https://france-agri-2025.agrocampus64.fr/dossier-accueil.pdf",
  },
};

export default config;
